import type { IconSvgObject } from './types';

const FileBracesCornerIcon: IconSvgObject = [
  ["path", { d: "M5 10V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 14C9.55228 14 10 14.4477 10 15V17C10 17.5523 10.4477 18 11 18C10.4477 18 10 18.4477 10 19V21C10 21.5523 9.55228 22 9 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 14C4.44772 14 4 14.4477 4 15V17C4 17.5523 3.55228 18 3 18C3.55228 18 4 18.4477 4 19V21C4 21.5523 4.44772 22 5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FileBracesCornerIcon;
